import React from 'react';
import {
	Box, BoxProps, Typography, Paper,
} from "@mui/material";
import { makeStyles } from "tss-react/mui";

export interface AuthPaperProps {
	width?: number,
	leftColumn?: {
		width?: number,
		content?: React.ReactNode,
		items?: BoxProps & {
			title: React.ReactNode,
			icon?: React.ReactNode,
			mt?: number,
		}[],
		title?: React.ReactNode
	};
	rightColumn: React.ReactNode
}

const useStyles = makeStyles()({
	logo: {
		display: 'block',
		margin: '0 auto 16px',
		width: 38,
	}
});

export const AuthPaper: React.FC<AuthPaperProps> = props => {
	const { leftColumn, rightColumn, width = 680 } = props;
	const { classes } = useStyles();
	let leftContent: React.ReactNode = null;
	if (leftColumn) {
		if (leftColumn.content) {
			leftContent = leftColumn.content;
		} else {
			leftContent = (
				<>
					<Typography
						display='block'
						fontWeight='normal'
						lineHeight={1.5}
						mb={6}
						variant='h6'
					>
						{leftColumn.title}
					</Typography>
					{(leftColumn.items || []).map((item, idx) => {
						const { title, icon, ...boxProps } = item;
						return (
							<Box
								key={idx}
								display='flex'
								flexWrap='nowrap'
								mb={2}
								{...boxProps}
							>
								{icon && (
									<Box
										sx={{
											minWidth: {
												xs: 30,
												md: 50
											},
										}}
									>
										{icon}
									</Box>
								)}
								<Typography  variant='body2'>
									{title}
								</Typography>
							</Box>
						)
					})}
				</>
			);
		}
	}
	return (
		<Paper
			sx={{
				display: 'flex',
				margin: '0 auto',
				boxSizing: 'border-box',
				width,
				maxWidth: '100%',
				overflow: 'hidden',
				boxShadow: {
					xs: 0,
					sm: 1
				}
			}}
		>
			<Box display='flex' width='100%'>
				{leftColumn && (
					<Box sx={{
						height: '100%',
						backgroundColor: '#f9f9f9',
						flex: 1,
						display: {
							xs: 'none',
							sm: 'block'
						},
						pt: 3,
						pb: 2,
						px: 3
					}}>
						{leftContent}
					</Box>
				)}
				<Box sx={{
					pt: 4,
					pb: 2,
					px: {
						md: 4,
						xs: 2
					},
					flex: 1,
				}}>
					<Box sx={{
						display: {
							xs: 'none',
							md: 'block'
						}}}
					>
						<img className={classes.logo} src="/dist/img/logo.svg"/>
					</Box>
					{rightColumn}
				</Box>
			</Box>
		</Paper>
	);
}
